import { SortingValues } from '../../reports/shared/constants/filterAndSortingKeys';

export const userSortingOptions = (() => {
  const key = 'x.reports.user.my_team.list.sorting';
  return [
    {
      name: SortingValues.Firstname_asc,
      translationKey: `${key}.name_AtoZ`,
    },
    {
      name: SortingValues.Firstname_desc,
      translationKey: `${key}.name_ZtoA`,
    },
    {
      name: SortingValues.Lastname_asc,
      translationKey: `${key}.last_name_AtoZ`,
    },
    {
      name: SortingValues.Lastname_desc,
      translationKey: `${key}.last_name_ZtoA`,
    },
  ];
})();
